import { createStore } from 'vuex';
import users from './modules/users';
import modals from './modules/modals';

export default createStore({
  state: {
    isTheme: "light",
  },
  getters: {
  },
  mutations: {
    setTheme(state, theme) {
      state.isTheme = theme
    }
  },
  actions: {
    initializeTheme({ commit }) {
      const storedTheme = localStorage.getItem('isTheme');
      if (storedTheme) {
        commit('setTheme', storedTheme);
      } else {
        localStorage.setItem('isTheme', 'light');
        commit('setTheme', 'light');
      }
    },
    changeTheme({ commit }, theme) {
      localStorage.setItem('isTheme', theme);
      commit('setTheme', theme);
    }
  },
  modules: {
    users,
    modals,
  }
});
